/**
 * Demande d'ouverture de l'onglet « Comptes et TVA » de Comptabilité (depuis Paramètres) : un drapeau de session
 * lu une seule fois par le contrôleur Comptabilité (l'écran est reconstruit à chaque ouverture).
 */
const CLE = 'nexxus.compta.ouvrir_onglet_reglages';

export function demanderOngletReglagesComptables(): void {
  try {
    sessionStorage.setItem(CLE, '1');
  } catch {
    /* stockage indisponible : l'utilisateur ouvre l'onglet lui-même */
  }
}

/** Vrai (une seule fois) si l'ouverture de l'onglet a été demandée. */
export function ongletReglagesDemande(): boolean {
  try {
    const demande = sessionStorage.getItem(CLE) === '1';
    if (demande) sessionStorage.removeItem(CLE);
    return demande;
  } catch {
    return false;
  }
}

/** Active l'onglet « Comptes et TVA » dans la section Comptabilité (même effet que le clic sur l'onglet). */
export function activerOngletReglages(section: HTMLElement): void {
  const bouton = section.querySelector<HTMLElement>('.tabs .tab[data-on-click*="tab-cpt-reglages"]');
  const contenu = section.querySelector<HTMLElement>('#tab-cpt-reglages');
  if (!bouton || !contenu) return;
  bouton.parentElement?.querySelectorAll('.tab').forEach((t) => t.classList.remove('active'));
  bouton.classList.add('active');
  section.querySelectorAll('.tab-content').forEach((c) => c.classList.remove('active'));
  contenu.classList.add('active');
}
